'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { InternalProvider, attachSubComponents, useCombinedRefs, useMediaQuery, getChildByType, isComponentType } from '../../../util';
import { Size } from '../../../abstracts';
import { StyledProgressStepper as ProgressStepper } from '../elements';
import { ProgressStepperContainer } from '../TemplateProgressStepperContainer';
import { FlexTemplateButtonGroup as ButtonGroup } from './FlexTemplateButtonGroup';
import { BaseFlexTemplate, PageTitleContainer, MainPanelContainer, MainContentContainer } from './elements';
import { Heading } from '../Heading';
import { SidePanelContainer } from './SidePanelContainer';
import { Subheading } from '../Subheading';
import { TemplateContext } from '../TemplateContext';
export const FlexTemplate = attachSubComponents('FlexTemplate', /*#__PURE__*/forwardRef(({
  children,
  ref,
  progressStepper,
  mobileSidebarPosition = 'bottom',
  ...props
}, fRef) => {
  var _mainContentContainer;
  const combinedRef = useCombinedRefs(ref, fRef);
  const hasButtonGroup = !!getChildByType(children, ButtonGroup);
  const mainContentContainer = getChildByType(children, MainContentContainer);
  children = React.Children.toArray(children).filter(child => !isComponentType(child, MainContentContainer));
  const isMobile = useMediaQuery(`(max-width: ${Size.MD - 1}px)`);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(TemplateContext.Provider, {
    value: {
      progressStepper
    }
  }, /*#__PURE__*/React.createElement(BaseFlexTemplate, _extends({
    hasButtonGroup: hasButtonGroup,
    ref: combinedRef,
    progressStepper: progressStepper,
    mobileSidebarPosition: mobileSidebarPosition
  }, props), mobileSidebarPosition === 'after-heading' ? mainContentContainer === null || mainContentContainer === void 0 || (_mainContentContainer = mainContentContainer.props) === null || _mainContentContainer === void 0 ? void 0 : _mainContentContainer.children : mainContentContainer, children, isMobile && progressStepper)));
}), {
  MainContentContainer,
  ProgressStepper,
  ProgressStepperContainer,
  ButtonGroup,
  PageTitleContainer,
  MainPanelContainer,
  SidePanelContainer,
  Heading,
  Subheading
});